import React from 'react';
import { Bar, BarChart, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Panel } from '../../common/Panel';
import { toBn } from '../../../utils/bn';
import type { kpiValues } from '../../../utils/applicationQueue';
type Kpi = ReturnType<typeof kpiValues>;
export function ApplicationCharts({
  kpi
}: {
  kpi: Kpi;
}) {
  const typeData = [{
    name: 'সিএনজি/অটোরিকশা',
    value: kpi.cng,
    color: '#006A4E'
  }, {
    name: 'মোটরসাইকেল',
    value: kpi.mcl,
    color: '#003B71'
  }];
  const statusData = [{
    name: 'নতুন',
    value: kpi.new,
    color: '#2563eb'
  }, {
    name: 'যাচাই চলমান',
    value: kpi.processing,
    color: '#f59e0b'
  }, {
    name: 'অনুমোদনের অপেক্ষায়',
    value: kpi.awaiting,
    color: '#0ea5e9'
  }, {
    name: 'অনুমোদিত',
    value: kpi.approved,
    color: '#059669'
  }, {
    name: 'সংশোধনে ফেরত',
    value: kpi.returned,
    color: '#d97706'
  }, {
    name: 'বাতিল',
    value: kpi.rejected,
    color: '#dc2626'
  }];
  const fmt = (v: number) => toBn(v.toLocaleString('en-IN'));
  return <div className="mb-5 grid gap-4 lg:grid-cols-5" data-id="element-128" data-mp="3eyj4yy4gcxpt">
      <Panel title="গাড়ির ধরন অনুযায়ী আবেদন" className="lg:col-span-2" bodyClassName="p-4" data-id="element-129" data-mp="3jqamkj5mrt3t">
        <div className="flex items-center gap-4" data-id="element-130" data-mp="3js5be8k0w5d6">
          <div className="h-40 w-40 shrink-0" data-id="element-131" data-mp="35zyw0oop22es">
            <ResponsiveContainer width="100%" height="100%" data-id="element-132" data-mp="35x2uyrhjuxm4">
              <PieChart data-id="element-133" data-mp="3ayigeknn3651">
                <Pie data={typeData} dataKey="value" innerRadius={44} outerRadius={70} paddingAngle={2} stroke="none" data-id="element-134" data-mp="3avwbkss4v4qi">
                  {typeData.map(d => <Cell key={d.name} fill={d.color} data-id="element-135" data-mp="6kago28yqt3g" />)}
                </Pie>
                <Tooltip formatter={(v: number) => fmt(v)} data-id="element-136" data-mp="3opdss6xck5dd" />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <ul className="flex-1 space-y-3" data-id="element-137" data-mp="3tnfb2pmy80ns">
            {typeData.map(d => <li key={d.name} data-id="element-138" data-mp="2d9p49b4g2yag">
                <p className="flex items-center gap-2 text-xs text-slate-500" data-id="element-139" data-mp="2d9gp1ckungw3"><span className="h-2.5 w-2.5 rounded-sm" style={{
                background: d.color
              }} data-id="element-140" data-mp="2i9upo9k4fok3" />{d.name}</p>
                <p className="font-heading text-xl font-bold text-navy-900" data-id="element-141" data-mp="1y7qdwmxautwj">{fmt(d.value)}</p>
                <p className="text-[11px] text-slate-400" data-id="element-142" data-mp="1u5vc7hbgiei8">মোটের {toBn(Math.round(d.value / (kpi.cng + kpi.mcl) * 100))}%</p>
              </li>)}
          </ul>
        </div>
      </Panel>
      <Panel title="আবেদন প্রক্রিয়াকরণের অবস্থা" className="lg:col-span-3" bodyClassName="p-4" data-id="element-143" data-mp="1kg27n09qeznh">
        <div className="h-40" data-id="element-144" data-mp="1fgh7wnmqmn9p">
          <ResponsiveContainer width="100%" height="100%" data-id="element-145" data-mp="1fhih0mk70zos">
            <BarChart data={statusData} layout="vertical" margin={{
            left: 8,
            right: 24
          }} data-id="element-146" data-mp="1ahw3ec0gdhfg">
              <XAxis type="number" hide data-id="element-147" data-mp="16g15lhhqdm6f" />
              <YAxis type="category" dataKey="name" width={118} tick={{
              fontSize: 11,
              fill: '#475569'
            }} axisLine={false} tickLine={false} data-id="element-148" data-mp="16h2epgf6ryli" />
              <Tooltip formatter={(v: number) => fmt(v)} cursor={{
              fill: '#f1f5f9'
            }} data-id="element-149" data-mp="11j0uut9xrv8z" />
              <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={14} label={{
              position: 'right',
              fontSize: 11,
              fill: '#0f172a',
              formatter: (v: number) => fmt(v)
            }} data-id="element-150" data-mp="30taeb72gd3nm">
                {statusData.map(d => <Cell key={d.name} fill={d.color} data-id="element-151" data-mp="33dyn2zrsognp" />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Panel>
    </div>;
}